import type { NuxtApp } from "#app";

export type FeatureName =
  | "freeAccessCommercialRent"
  | "folderTemplates"
  | "forceThirdPartyError"
  | "portfolio"
  | "portfolioDataWarehouse"
  | "rentalData"
  | "rentalDataSimulations"
  | "bofpDocuments"
  | "personSearchLoginWarningTest"
  | "advancedSearchAllResults"
  | "balanceKeyFigures"
  | "arrearsBeta";

export type FeatureFlag = {
  name: FeatureName;
  active: boolean;
  routes: string[];
};

function isFeature(app: NuxtApp) {
  return app.$config.public.buildVariant === "feature";
}

function isDev(app: NuxtApp) {
  return app.$config.public.buildVariant === "dev";
}

export const featureFlags: (app: NuxtApp) => FeatureFlag[] = (app) => [
  {
    name: "rentalData",
    active: true,
    routes: ["explore-property-id-rental-levels"],
  },
  {
    name: "rentalDataSimulations",
    active: true,
    routes: [],
  },
  {
    name: "bofpDocuments",
    active: isDev(app) || isFeature(app),
    routes: [],
  },
  {
    name: "personSearchLoginWarningTest",
    active: false,
    routes: [],
  },
  {
    name: "advancedSearchAllResults",
    active: false,
    routes: [],
  },
  {
    name: "freeAccessCommercialRent",
    active: false,
    routes: [],
  },
  {
    name: "folderTemplates",
    active: true,
    routes: [],
  },
  {
    name: "forceThirdPartyError",
    active: false,
    routes: [],
  },
  {
    name: "portfolio",
    active: true,
    routes: ["portfolio", "portfolio-properties", "portfolio-tenancies"],
  },
  {
    name: "portfolioDataWarehouse",
    active: isDev(app) || isFeature(app),
    routes: ["datawarehouse"],
  },
  {
    name: "balanceKeyFigures",
    active: isDev(app) || isFeature(app),
    routes: [],
  },
  {
    name: "arrearsBeta",
    active: true,
    routes: [],
  },
];
